//--------DOCUMENTATION--------
//This widget has 2 modes for the view: 1) a condensed version, and 2) a full version.  By default, only the condensed 
//version is shown, and the full version is called via AJAX from within the short version.

//    Dependencies:
//1. CDN Chartist.CSS <link rel="stylesheet" href="bower_components/chartist/dist/chartist.min.css">
//2. CDN Chartist.js  <script src="bower_components/chartist/dist/chartist.min.js">
//3. ArticleLevelMetrics.js --> which should ship over in the SharedWidgets NuGet Package
//4. _article-level-metrics.scss --> default presentation for the widget. should ship over with NuGet Package.

var ArtMetric = {};

ArtMetric.fullVersion = function ($dest, routeUrl, onLoaded) {
    var $modal = $dest.closest('.js-artmet-modal');
    // Only do AJAX call if it hasn't been done before.
    if ($dest.find('.widget-ArticleLevelMetrics').length < 1) {
        var baseSiteUrl = $('#hfSiteURL');
        if (typeof baseSiteUrl != 'undefined' && typeof baseSiteUrl.val() != 'undefined' && baseSiteUrl != '') {
            routeUrl = '//' + baseSiteUrl.val() + routeUrl;
        }

        // Hide the white modal panel while the request is in flight so keyboard
        // users don't land in an empty modal whose focus trap can only see the
        // close button. Backdrop stays visible to signal that something is happening.
        $modal.addClass('is-loading');

        $.ajax({
            url: routeUrl,
            datatype: 'HTML',
            success: function (html) {
                $dest.prepend(html);

                setTimeout(function () {
                    if (typeof window.ChartistData !== 'undefined') {
                        ArtMetric.chartLoad($dest);
                    }
                }, 200);
                ArtMetric.reloadDimensionsBadge();

                $modal.removeClass('is-loading');
                if (typeof onLoaded === 'function') { onLoaded(); }
            },
            error: function (xmlHttpRequest, textStatus, errorThrown) {
                $modal.removeClass('is-loading');
                if (window.console) {
                    var err = eval('(' + xmlHttpRequest.responseText + ')');
                    console.error('error: ' + err);
                    console.error('status: ' + textStatus);
                }
                if (typeof onLoaded === 'function') { onLoaded(); }
            }
        });
    }
    else if (typeof onLoaded === 'function') {
        onLoaded();
    }
};

ArtMetric.reloadDimensionsBadge = function () {
    var hasDimensionsWidget = $('.contentmet-dimensions').length || $('.artmet-dimensions').length;
    if (hasDimensionsWidget &&
        window.__dimensions_embed &&
        window.__dimensions_embed.addBadges) {
        if ($('.__dimensions_badge_embed__').length) {
            $('.__dimensions_badge_embed__').removeAttr('data-dimensions-badge-installed');
            $('.__dimensions_badge_embed__').empty();
        }
        window.__dimensions_embed.addBadges();
    }
}

ArtMetric.limitLabels = function () {
    // limit which labels are being displayed
    var xAxisLabels = $('.ct-horizontal.ct-label');
    var labelCt = xAxisLabels.length;

    // max number of labels to show is 8. so if there are 16..we'll show every other. 24 -- every third, etc.
    var showNthLabel = Math.ceil(labelCt / 8);
    var counter = 1;

    xAxisLabels.not(':eq(0)').each(function () {
        if (!(counter % showNthLabel === 0)) {
            $(this).hide();
        }
        counter++;
    });
};

ArtMetric.createChart = function (cssSelector, data, options, responsiveOptions) {
    var chart = new Chartist.Line(cssSelector, data, options, responsiveOptions);

    // Let's put a sequence number aside so we can use it in the event callbacks
    var seq = 0,
        delays = 25,
        durations = 250;

    // Once the chart is fully created we reset the sequence
    chart.on('created', function () {
        seq = 0;

        ArtMetric.limitLabels();
    });

    chart.on('draw', function (data) {
        if (data.type === 'line' || data.type === 'point' || data.type === 'area') {
            seq++;
        }

        if (data.type === 'line') {
            data.element.animate({
                opacity: {
                    begin: seq * delays + 150,
                    dur: durations,
                    from: 0,
                    to: 1
                }
            });
        } else if (data.type === 'point') {
            data.element.animate({
                x1: {
                    begin: seq * delays,
                    dur: durations,
                    from: data.x - 10,
                    to: data.x,
                    easing: 'easeOutQuart'
                },
                x2: {
                    begin: seq * delays,
                    dur: durations,
                    from: data.x - 10,
                    to: data.x,
                    easing: 'easeOutQuart'
                },
                opacity: {
                    begin: seq * delays,
                    dur: durations,
                    from: 0,
                    to: 1,
                    easing: 'easeOutQuart'
                }
            });
        } else if (data.type === 'area') {
            data.element.animate({
                opacity: {
                    begin: seq * delays + 250,
                    dur: 300,
                    from: 0,
                    to: 1
                }
            });
        }
    });
};

function getWidgetInstanceName(widgetClass) {
    var widgetInstanceName = '';
    var className = $(widgetClass).attr('class');
    var widgetInstanceIdx = className.indexOf('widget-instance-');
    if (widgetInstanceIdx >= 0) {
        widgetInstanceName = className.substr(widgetInstanceIdx).split('-')[2];
    }
    return widgetInstanceName;
}

ArtMetric.lastActiveElement = null;

ArtMetric.triggerModal = function ($modal, articleId) {
    var showDimensionsBadge = $('.artmet-dimensions').length ? 'true' : 'false';
    var routeUrl = '/ThirdParty/ArticleLevelMetricsDetails';
    var widgetInstance = getWidgetInstanceName('.widget-ArticleLevelMetrics');
    if (widgetInstance.length > 0) {
        routeUrl += '/' + widgetInstance;
    }
    routeUrl += '?articleId=' + articleId + '&showDimensionsBadge=' + showDimensionsBadge;

    var $modalWrap = $('.artmet-modal');
    $modalWrap.css({ 'display': 'block', 'opacity': 1 });
    $modalWrap.attr('aria-hidden', 'false');
    $modalWrap.find('.js-metric-full-wrap').attr('aria-hidden', 'false');
    $('body').addClass('metrics-modal-open');
    ArtMetric.lastActiveElement = document.activeElement;
    $('.js-artmet-modal-trigger').attr('aria-expanded', 'true');

    // Move focus to the close button and bind the focus trap only after the
    // modal content has been fetched (immediately if cached). Doing this
    // earlier captures a focusables list that only contains the close button
    // (the AJAX content isn't in the DOM yet), so Tab cycles X -> X and looks
    // broken. The keydown handler re-queries the focusables on every press so
    // any content added later (chart, badges) is included automatically.
    ArtMetric.fullVersion($modal, routeUrl, function () {
        var focusablesSelector = 'a[href], button, textarea, input:not([type="hidden"]), select';

        var $focusables = $modalWrap.find(focusablesSelector).filter(':visible:not(:disabled)');
        if ($focusables.length) {
            $focusables.first().focus();
        } else {
            $modalWrap.attr('tabindex', '0').focus();
        }

        $modalWrap.off('keydown.metricsModalTrap');
        $modalWrap.on('keydown.metricsModalTrap', function (e) {
            if (e.key === 'Tab') {
                var $live = $modalWrap.find(focusablesSelector).filter(':visible:not(:disabled)');
                if (!$live.length) {
                    e.preventDefault();
                    return;
                }
                var first = $live[0];
                var last = $live[$live.length - 1];
                if (e.shiftKey) {
                    if (document.activeElement === first || !$live.is(document.activeElement)) {
                        e.preventDefault();
                        last.focus();
                    }
                } else {
                    if (document.activeElement === last || !$live.is(document.activeElement)) {
                        e.preventDefault();
                        first.focus();
                    }
                }
            } else if (e.key === 'Escape') {
                ArtMetric.closeModal();
            }
        });
    });
};

ArtMetric.closeModal = function () {
    var $modalWrap = $('.artmet-modal:visible');
    $modalWrap.attr('aria-hidden', 'true');
    $modalWrap.attr('style', '');
    $modalWrap.find('.js-metric-full-wrap').attr('aria-hidden', 'true');
    $modalWrap.off('keydown.metricsModalTrap');
    $('body').removeClass('metrics-modal-open');
    $('.js-artmet-modal-trigger').attr('aria-expanded', 'false');
    if (ArtMetric.lastActiveElement) {
        ArtMetric.lastActiveElement.focus();
        ArtMetric.lastActiveElement = null;
    }
};

ArtMetric.chartLoad = function ($container) {
    var opts = {
        lineSmooth: false,
        showArea: true,
        low: 0
    };

    var responsiveOpts = [
        ['screen and (max-width: 1024px)', {
            axisX: {
                labelInterpolationFnc: function (value) {
                    return value.slice(0, 3);
                }
            }
        }],
        ['screen and (min-width: 1px)', {
            axisX: {
                labelInterpolationFnc: function (value) {
                    return value;
                }
            }
        }]
    ];
    let chartSelector = `#${$container.attr('id')} .ct-chart`;
    ArtMetric.createChart(chartSelector, window.ChartistData.data, opts, responsiveOpts);
};

ArtMetric.eventsToClose = function () {
    $('.js-artmet-close-modal').on('click keydown', function (e) {
        if (e.type === 'click' || (e.type === 'keydown' && (e.key === 'Enter' || e.key === 'Space'))) {
            e.preventDefault();
            ArtMetric.closeModal();
        }
    });

    $('.js-artmet-modal').click(function () {
        if (!$(event.target).closest('.artmet-modal-contents').length) {
            ArtMetric.closeModal();
        }
    });
};

ArtMetric.autoLoadChart = function($artmetWrap) {
    const chartContainer = document.querySelector('.artmet-full-wrap');
    // in split screen, the chart container will have no width until the tab is selected. Need to wait to initialize the chart until the container has width
    const resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
            const width = entry.contentRect.width;
            if (width > 0) {
                ArtMetric.chartLoad($artmetWrap);
                resizeObserver.disconnect();
            }
        }
    });
    resizeObserver.observe(chartContainer);
};

$(document).ready(function () {
    $('.artmet-modal-trigger, .artmet-condensed-stats .artmet-views').click(function () {
        var articleId = $('.artmet-modal-trigger').attr('data-article-id');
        ArtMetric.triggerModal($('.artmet-modal-contents'), articleId);
    });

    // The trigger is an <a role="button">; anchors fire click on Enter natively
    // but not on Space, so forward Space to a synthetic click.
    $(document).on('keydown', '.artmet-modal-trigger', function (e) {
        if (e.key !== ' ' && e.keyCode !== 32) {
            return;
        }
        e.preventDefault();
        $(this).trigger('click');
    });

    ArtMetric.eventsToClose();

    $('.__dimensions_badge_embed__').on('dimensions_embed:show', function () {
        $('.__dimensions_badge_embed__').closest('.artmet-item').removeClass('hide');
        $('.__dimensions_badge_embed__').closest('.contentmet-citations').removeClass('hide');
    });
    $('.altmetric-embed').on('altmetric:show', function () {
        $('.altmetric-embed').closest('.artmet-item').removeClass('hide');
    });

    const $artmetWrap = $('.artmet-full-wrap');
    const autoloadChart = $artmetWrap.data('autoloadChart');

    if (autoloadChart != undefined) {
        if (autoloadChart === true || autoloadChart.toLowerCase() === 'true') {

            ArtMetric.autoLoadChart($artmetWrap);
        }
    }    
});


